import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import pt from "./locales/pt.json";
import en from "./locales/en.json";
import es from "./locales/es.json";

// Configuracao central de idiomas do app do cliente (frontend). Fase 1 do
// projeto de internacionalizacao (i18n) -- comeca pela landing page e login,
// as demais telas do painel vem nas proximas fases. Ver conversa de
// 18/08/2026 sobre expansao internacional (EN/ES) + pagamento via Stripe.
//
// LanguageDetector: detecta idioma salvo no localStorage (chave
// "saasgl_idioma") primeiro; se nao houver, cai pro idioma do navegador; se
// nao bater com nenhum idioma suportado, usa o fallback ("pt" -- publico
// majoritario do produto ainda e' o Brasil).
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      pt: { translation: pt },
      en: { translation: en },
      es: { translation: es },
    },
    fallbackLng: "pt",
    supportedLngs: ["pt", "en", "es"],
    nonExplicitSupportedLngs: true,
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "saasgl_idioma",
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false },
  });

export default i18n;
